export const fileTypeTypes = Object.freeze({
  File: 0,
  Signature: 1,
  OriginalPdfForm: 2,
  UserPdfForm: 3,
  MarketingFormDefault: 4,
  Folder: 5,
  PdfFormReverseMapping: 6,
  PdfFormReverseMappingFilled: 7,
});
